<template>
  <div
    @click.self="closeModal"
    class="modalContainer"
    ref="modal"
    role="dialog"
    tabindex="-1"
    aria-modal="true"
    aria-hidden="false"
  >
    <div class="modalWrapper">
      <div @click="closeModal" class="close" tabindex="0" aria-label="Close modal" role="button">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
            fill="black"
            stroke="black"
          />
        </svg>
      </div>
      <h2 aria-live="polite" aria-atomic="true" class="title">Filters</h2>
      <div class="hr"></div>
      <div v-if="sortedAllergens.length || sortedFilteredPreferences.length" class="card">
        <div class="cardInfoWrapper" v-if="sortedAllergens">
          <h2 class="filters">Flag your Allergen(s)</h2>
          <p class="text">
            Select all the items that you cannot consume below. Flagged items will be marked in
            <span style="color: red">red</span>
          </p>
        </div>
        <div class="options" v-if="sortedAllergens">
          <div
            v-for="(allergens, index) in sortedAllergens"
            :key="index"
            class="filter"
            @click="selectFiltersAllergens(allergens, index)"
            @keyup.enter="selectFiltersAllergens(allergens, index)"
            :class="{ clicked: localSelectedAllergens.includes(allergens.id) }"
            tabindex="0"
            role="button"
            :aria-label="'Select allergen: ' + allergens.name"
          >
            <p v-if="allergens.name">{{ allergens.name }}</p>
          </div>
        </div>
        <div class="cardInfoWrapper" v-if="sortedFilteredPreferences">
          <h2 class="filters">Flag your Preference</h2>
          <p class="text">Select a dietary preference below. Flagged items will be marked with a badge</p>
        </div>
        <div class="options" v-if="sortedFilteredPreferences">
          <div
            v-for="(preferences, index) in sortedFilteredPreferences"
            :key="index"
            class="filter"
            @click="selectFilterItemClasses(preferences, index)"
            @keyup.enter="selectFilterItemClasses(preferences, index)"
            :class="{ clicked: localSelectedItemClasses.includes(preferences.id) }"
            tabindex="0"
            role="button"
            :aria-label="'Select preference: ' + preferences.name"
          >
            <p v-if="preferences.name">{{ preferences.name }}</p>
          </div>
        </div>
      </div>
      <div v-else class="no-filters-message">
        <p>There are no filters available to select.</p>
      </div>
      <div class="hr"></div>
      <div class="modalFooter">
        <div class="checkbox-container" v-if="loggedIn">
          <input
            v-model="checkbox"
            type="checkbox"
            id="filterCheckbox"
            class="checkbox"
            :disabled="isCheckboxDisabled"
            tabindex="0"
          />
          <p @click="toggleCheckbox" @keyup.enter="toggleCheckbox" for="filterCheckbox" class="filterCheckbox" tabindex="0">
            Save settings to my profile
          </p>
        </div>
        <div :class="{ 'button-container': true, 'full-width-buttons': !loggedIn }">
          <button class="clearbutton" @click="clearFilter" :disabled="isClearDisabled">
            <p>Clear</p>
          </button>
          <button @click="applyFilter" tabindex="0">
            <p>See Results</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customersApi from '@/api/customersApi.js'
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      localSelectedAllergens: [],
      localSelectedItemClasses: [],
      checkbox: false,
      selectedAllergens: [],
      selectedItemClasses: [],
    }
  },
  computed: {
    ...mapState(['loggedIn']),
    isClearDisabled() {
      return this.localSelectedAllergens.length === 0 && this.localSelectedItemClasses.length === 0
    },
    isCheckboxDisabled() {
      if (this.localSelectedAllergens.length === 0 && this.localSelectedItemClasses.length === 0) {
        return true
      }
      return (
        JSON.stringify(this.localSelectedAllergens) === JSON.stringify(this.selectedAllergens) &&
        JSON.stringify(this.localSelectedItemClasses) === JSON.stringify(this.selectedItemClasses)
      )
    },
    filteredPreferences() {
      return this.preferencesItemClass.filter((preference) => preference.is_filter)
    },
    sortedAllergens() {
      return this.preferencesAllergen.slice().sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    sortedFilteredPreferences() {
      return this.preferencesItemClass.slice().sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
  },
  props: ['selectedAllergen', 'selectedItemClass', 'preferencesAllergen', 'preferencesItemClass'],
  created() {
    this.localSelectedAllergens = [...this.selectedAllergen]
    this.localSelectedItemClasses = [...this.selectedItemClass]

    if (this.loggedIn) {
      this.getPreferences()
    }
  },
  watch: {
    isClearDisabled(newValue) {
      if (newValue) {
        this.checkbox = false
      }
    },
  },
  methods: {
    ...mapMutations(['SET_ITEM_TOASTER']),
    closeModal() {
      this.$emit('closeModal')
    },
    clearFilter() {
      this.localSelectedAllergens = []
      this.localSelectedItemClasses = []
      this.$emit('clear-selected-filters')
    },
    selectFiltersAllergens(selected) {
      const idx = this.localSelectedAllergens.indexOf(selected.id)
      if (idx === -1) {
        this.localSelectedAllergens.push(selected.id)
      } else {
        this.localSelectedAllergens.splice(idx, 1)
      }
    },

    selectFilterItemClasses(selected) {
      if (this.localSelectedItemClasses.length > 0 && !this.localSelectedItemClasses.includes(selected.id)) {
        this.localSelectedItemClasses = [selected.id]
      } else {
        const idx = this.localSelectedItemClasses.indexOf(selected.id)
        if (idx === -1) {
          this.localSelectedItemClasses.push(selected.id)
        } else {
          this.localSelectedItemClasses.splice(idx, 1)
        }
      }
    },
    applyFilter() {
      this.$emit('applyFilter', this.localSelectedAllergens, this.localSelectedItemClasses)
      if (this.checkbox) {
        this.saveFilters()
      }
      this.closeModal()
    },
    saveFilters() {
      let customerID = localStorage.getItem('customerId')
      let payload = {
        exc_allergens: this.localSelectedAllergens,
        inc_item_classes: this.localSelectedItemClasses,
      }
      customersApi
        .setPreferences(customerID, payload)
        .then((response) => {
          if (response) {
            let toasterData = {
              show: true,
              message: 'Changes successfully saved',
            }
            this.SET_ITEM_TOASTER(toasterData)
          }
        })
        .catch((error) => {
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session has expired. Please log in again',
            }
            this.SET_ITEM_TOASTER(toasterData)
            this.$emit('logout')
          }
          this.error.status = true
          this.error.message = 'Something went wrong. Please try again'
        })
    },
    toggleCheckbox() {
      if (this.isCheckboxDisabled) {
        return
      }
      this.checkbox = !this.checkbox
    },
    getPreferences() {
      let customerID = localStorage.getItem('customerId')
      customersApi
        .getPreferences(customerID)
        .then((response) => {
          let prefs = response?.data?.data?.prefs

          if (prefs.exc_allergens) {
            this.selectedAllergens = this.selectedAllergens.concat(prefs.exc_allergens)
          }
          if (prefs.inc_item_classes) {
            this.selectedItemClasses = this.selectedItemClasses.concat(prefs.inc_item_classes)
          }
        })
        .catch((error) => {
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session has expired. Please log in again',
            }
            this.SET_ITEM_TOASTER(toasterData)
            this.$emit('logout')
          }
          this.error.status = true
          this.error.message = 'Something went wrong. Please try again'
        })
    },
    trapFocus(event) {
      if (event.key === 'Tab') {
        const modal = this.$refs.modal
        if (!modal) {
          return
        }

        const focusableElements = modal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey) {
          // Backward tab
          if (document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          }
        } else {
          // Forward tab
          if (document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }
    },
  },
  mounted() {
    this.$refs.modal.focus()
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this.trapFocus)
  },
  beforeUnmount() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this.trapFocus)
  },
}
</script>

<style src="../../../assets/css/Modals/FilterModals/FilterModalAllergen.css" scoped></style>